import { request } from '@blade/common';
/**
*@Description: 租户-查询用户配置
*/
export const getOperateConfig = () => request.get(`/api/user-management/api/v1/ums/tenant/conf/portal`);
/**
*@Description: 租户-保存配置
*/
export const postOperateSaveConfig = (data) => request({
    url: '/api/user-management/api/v1/ums/tenant/conf/portal',
    method: 'POST',
    data
});
/**
*@Description: 租户-上传图片到服务器,返回图片访问地址
*/
export const postOperateUploadImage = (data) => request({
    url: '/api/user-management/api/v1/ums/tenant/conf/uploadImage',
    method: 'POST',
    data,
});
